/*eslint-disable */
export default {
  name: 'pw-changed-successfully-popup',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
    setTimeout(() => {
      this.$router.push('/');
    }, 2200)
  },
  methods: {
  }
}